// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2pgZt","title":"Images45_title__zXAhk","images":"Images45_images__173BA"};